import * as React from 'react';
import cx from 'classnames';
import "./styles.scss";
var styles = {
  "loading": "_2yNQg",
  "dot": "s6Zx9"
};

var LoadingRenderFunction = function (_ref, ref) {
  var className = _ref.className,
      color = _ref.color;
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: cx(styles.loading, className),
    style: {
      color: color
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.dot
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.dot
  }));
};

export var Loading = /*#__PURE__*/React.forwardRef(LoadingRenderFunction);
export default Loading;